import { render, staticRenderFns } from "./PortalUpdatesBell.vue?vue&type=template&id=2fae8486&scoped=true"
import script from "./PortalUpdatesBell.vue?vue&type=script&lang=js"
export * from "./PortalUpdatesBell.vue?vue&type=script&lang=js"
import style0 from "./PortalUpdatesBell.vue?vue&type=style&index=0&id=2fae8486&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fae8486",
  null
  
)

export default component.exports